import ResourceModel from "models/convention-api/ResourceModel"

export default class ChatAvailable extends ResourceModel {
  protected static basePath = "v1/convention_providers/:provider_id/chat_availables"

  status!: "off" | "on" | "away"
}
